<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4">
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>個人資訊</h3>
                </div>
              </div>
              <div class="widget-container">
                <div class="widget-content">
                  <div class="row">
                    <div class="col-md-6 col-md-offset-3 text-center">
                      <div class="pointer"  @click="uploadAvatarModal=true">
                        <img v-if="user.profile_pic != ''" class="img-responsive rounded-circle" v-bind:src="user.profile_pic">
                        <img class="img-responsive rounded-circle" v-else src="../../assets/img/cats/03.jpg">
                        <small>點擊更換大頭照</small>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="widget-content">
                  <div class="row">
                    <div class="col-md-10">
                      <div class="form-horizontal">
                        <div class="form-group">
                          <label class="col-md-4 control-label">姓名</label>
                          <div class="col-md-8">
                            <input type="text" class="form-control" v-model="user.name">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-md-4 control-label">Email</label>
                          <div class="col-md-8">
                            <input type="text" v-model="user.email" class="form-control" disabled="disabled">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-md-4 control-label">職位</label>
                          <div class="col-md-8">
                            <input type="text" v-model="user.title" class="form-control">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-md-4 control-label">聯絡電話</label>
                          <div class="col-md-8">
                            <input type="text" v-model="user.phone" class="form-control">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-md-4 control-label">&nbsp;</label>
                          <div class="col-md-8">
                            <div class="form-actions">
                              <button @click="updateUser(user.user_token)" class="btn btn-primary">修改</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div>
                  <h3 class="text-left">個人業績目標
                    <span class="pull-right" v-if="user.sales_target">目前的每月預定目標： $ {{user.sales_target.toLocaleString()}} 
                      <button @click="setMonthTarget=true" class="btn btn-success btn-xs"><i class="fa fa-cog"></i></button>
                    </span>
                  </h3>
                </div>
              </div>
              <div class="widget-container">
                <div class="widget-content" v-if="!user.sales_target">
                  你可以設定你的預設業績目標，將會自動產生每個月的業績目標。<br>你也可以之後依照狀況調整每個月的業績目標
                  <button @click="setMonthTarget=true" class="btn btn-success"><i class="fa fa-cog"></i> 設定目標</button>
                  <br>
                </div>
                <h4>{{target_year}} 的每月業績目標</h4>
                <h4>目標：${{totalTarget.toLocaleString()}} , 達成：${{totalAmount.toLocaleString()}} , 達成率：{{parseInt(totalAmount*100/totalTarget || 0)}}%</h4>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">月份</th>
                      <th class="text-center">達成件數</th>
                      <th class="text-center">達成金額/目標</th>
                      <th class="text-center">月達成率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="target in filterTargets" v-bind:class="{ 'table-success': thisMonth(target)}">
                      <td>{{target.month}}</td>
                      <td>{{target.deal_number}}</td>
                      <td>
                        <span v-if="target_edit=='no' || target_edit!=('target_value'+target.id)" @click="editTextClick(('target_value'+target.id),target)">${{target.deal_amount.toLocaleString()}} / ${{target.target.toLocaleString()}} <i class="fa fa-pen"></i></span>
                        <input type="number" v-bind:ref="('target_value'+target.id)" class="form-control" v-if="target_edit==('target_value'+target.id)" v-model="temp_target" @keypress="isNumber($event)" @keydown.enter="$event.target.blur()" v-on:blur="saveTarget(target)">
                      </td>
                      <td>
                        <span v-if="target.target!=0">{{parseInt(target.deal_amount*100 / target.target) }}%</span>
                        <span v-else>-</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start-->
    <div v-if="uploadAvatarModal" @keyup.esc="uploadAvatarModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="uploadAvatarModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                上傳新的大頭照
              </div>
              <a href="#" class="btn-close" @click="uploadAvatarModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <dropzone 
                  id="myVueDropzone" 
                  :url="axios.defaults.baseURL + '/users/update_profile_pic'" 
                  :headers=auth_token
                  :maxFileSizeInMB='12'
                  @vdropzone-success="vsuccess"
                  >
                </dropzone>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-default" @click="uploadAvatarModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="setMonthTarget" @keyup.esc="setMonthTarget=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="uploadAvatarModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                設定你的每月目標
              </div>
              <a href="#" class="btn-close" @click="setMonthTarget = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <label>月目標(請輸入數字)</label>
                <input type="number" class="form-control" placeholder="ex: 1200000" v-model="user.sales_target">
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-success" @click="updateUser(user.user_token);setMonthTarget = false">
                  確定
                </button>
                <button class="btn btn-default" @click="setMonthTarget = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!--Page Container End Here-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'

export default {
  name: 'hello',
  components: {
    Simplert,Dropzone
  },
  data() {
    return {
      auth_token: '',
      uploadAvatarModal: false,
      setMonthTarget: false,
      target_year: (new Date().getFullYear()).toString(),
      target_edit: 'no',
      temp_target: 0,
    }
  },
  computed: {
    filterTargets: function () {
      var result = []
      if(this.user.sales_targets){
        result = this.user.sales_targets.filter(target => target.year == parseInt(this.target_year))
        result = result.sort( ( a, b) => {
          return a.month - b.month;
        });
      }
      return result
    },
    totalTarget: function () {
      var result = 0
      if(this.filterTargets.length>0){
        result = this.filterTargets.reduce((acc, item) => acc + item.target, 0);
      }
      return result
    },
    totalAmount: function () {
      var result = 0
      if(this.filterTargets.length>0){
        result = this.filterTargets.reduce((acc, item) => acc + item.deal_amount, 0);
      }
      return result
    },
  },
  created() {
    // this.getUserProfile()
  },
  props: ['toggle_aside','user'],
  methods: {
    vsuccess(file, response) {
      this.getUserProfile();
      this.uploadAvatarModal=false
      // window.toastr.success('', 'Event : vdropzone-success')
    },
    getUserProfile() {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }

      // defiine vm to assign this (assign vue data) because in axios there is other this
      const vm = this;
      this.axios.get('settings/get_user_profile').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.user = response['data']['data']['user']
          } else {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    thisMonth(target){
      var nowYear = (new Date().getFullYear()).toString()
      var nowMonth = (new Date().getMonth()+1).toString()
      if(target.year.toString() == nowYear && target.month.toString() == nowMonth ){
        return true
      }else{
        return false
      }
    },
    saveTarget(target){
      let vm = this
      this.target_edit='no'
      target.target = parseInt(this.temp_target||0)
      this.axios.post('users/update_single_target', {
        target: target
      })
      .then(function(response) {
        if (response.status == 200) {

        } else {
          toastr.danger('更新失敗，請再試一次，或稍後再試')
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    editTextClick(n,target){
      var vm = this
      this.target_edit = n
      this.temp_target = target.target
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[n])){
          vm.$refs[n][0].focus()
        }else{
          vm.$refs[n].focus()
        }
      })
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    updateUser(user_token) {
      const vm = this;
      this.axios.put('users/:id', {
        user: {
          name: vm.user.name,
          phone: vm.user.phone,
          title: vm.user.title,
          sales_target: vm.user.sales_target,
          user_token: vm.user.user_token,
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          var obj = {
            isShown: true,
            title: '更新成功',
            type: 'success',
            hideAllButton: true
          }
          vm.$refs.simplert.openSimplert(obj);
          vm.user = response['data']['data']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
  },
}
</script>


// WEBPACK FOOTER //
// UserProfile.vue?14b5578c